<div class="chip">
  <span class="chip__text">
    <ng-content></ng-content>
  </span>
</div>
